import { AddressResp } from 'models/Addresses';

const emptyCompanyAddress: AddressResp = {
    id: '-1',
    name: 'Új címet adok meg',
    billingAddress: null,
    shippingAddress: {
        address1: '',
        address2: '',
        city: '',
        country: 'HU',
        postcode: null,
        phone: '',
    },
};

export default emptyCompanyAddress;
